import { apiRoutes } from "@constants/api-routes";
import { POLICY_COMPONENT_ID_PATTERN } from "@constants/url-parameter-patterns";
import { RequestTypes } from "@enums/request-types";
import { SimpleDeployedPolicyConfig } from "@idw-types/data/reference-data/axn/simple-deployed-policy-config";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { handleRequest } from "@utils/http-util";
import { injectCustomIdParameter } from "@utils/parameter-injector";

export const getPolicyComponentAffectedPoliciesRequest = async (
    id: string
): Promise<GenericNetworkResponse<Array<SimpleDeployedPolicyConfig>>> => {
    const route = injectCustomIdParameter(
        apiRoutes.serviceConfiguration.affectedPolicies,
        id,
        POLICY_COMPONENT_ID_PATTERN
    );

    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};